import { log } from './log';

export function resolveEventTimeStamp()
{
    log('info', 'lifecycle::resolveEventTimeStamp');

    return -1.1;
}
